import { Link } from 'react-router-dom';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../artist-help/styles.css';

const COLLECTOR_HELP_SECTIONS = [
  { key: 'get_started', to: '/profile/collector-help/get-started' },
  { key: 'find_and_select', to: '/profile/collector-help/find-and-select' },
  { key: 'purchase_originals', to: '/profile/collector-help/purchase-originals' },
  { key: 'limited_editions', to: '/profile/collector-help/limited-editions' },
  { key: 'artists_and_galleries', to: '/profile/collector-help/artists-and-galleries' },
  { key: 'support_subscriptions', to: '/profile/collector-help/support-subscriptions' },
  { key: 'shipping_and_returns', to: '/profile/collector-help/shipping-and-returns' },
];

export default function ProfileCollectorHelp() {
  const t = useTranslations('collectors_help.index');

  return (
    <section className="artist-help-profile">
      <header className="artist-help-profile__header">
        <GoBackButton alternativeRoute="/profile" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-profile__sections">
        {COLLECTOR_HELP_SECTIONS.map((section) => {
          if (section.to) {
            return (
              <Link key={section.key} to={section.to} className="artist-help-profile__section artist-help-profile__section--link">
                <h2>{t(`sections.${section.key}`)}</h2>
              </Link>
            );
          }

          return (
            <article key={section.key} className="artist-help-profile__section">
              <h2>{t(`sections.${section.key}`)}</h2>
            </article>
          );
        })}
      </div>
    </section>
  );
}
